import s from "./PartHeading.module.css";

export interface PartHeadingProps {
  number: number;
  title: string;
}

export function PartHeading({ number, title }: PartHeadingProps) {
  return (
    <div className={s.partHeading}>
      <span className={s.number} aria-hidden>
        {number}
      </span>
      <h2 className={s.title}>{title}</h2>
    </div>
  );
}
